import { from } from "rxjs";
import { APIResource, APIMethod } from "libs/utils/http/decorator/UrlDecorator";
import { apiMethodContext } from "libs/utils/http/builder/UrlConfig";
import { CloudConsoleClient } from "libs/utils/http/client/HttpClient";

export type IdentityApplicationEnvironmentType = "trimble-pre-prod" | "trimble-prod";



export interface IdentityApplicationPublishedGateway {
    consumerKey: string
    consumerSecret: string[]
    grantTypes?: string[]
    logoutUri?: string[]
    organisationName: IdentityApplicationEnvironmentType
    redirectUri?: string[]
    enforceScopeValidation?: boolean
}

export interface IdentityApplicationSPMetadata {
    assertionConsumerUrl: string;
    x509RequestSigningCert?: string;
}

export interface IdentityApplicationType {
    id: string;
    name: IdentityApplicationTypes
}

export interface IdentityApplication {
    applicationId: string,
    applicationName: string,
    applicationType?: IdentityApplicationType;
    displayName?: string,
    description?: string,
    organisationName: IdentityApplicationEnvironmentType;
    applicationGatewayResponses?: IdentityApplicationPublishedGateway[];
    samlSpMetadata?: IdentityApplicationSPMetadata;
    userId?: string;
    isOwnedByUser?: Boolean,
    createdBy?: string;
    consumerKey: string;
}

export interface IdentityApplicationCreateRequest {
    name?: string,
    displayName?: string,
    description?: string,
    applicationType: IdentityApplicationTypes;
}

export interface IdentityApplicationUpdateRequest {
    name: string;
    displayName?: string,
    description?: string
}

export interface IdentityApplicationPublishRequest {
    grantTypes?: string[],
    redirectUri?: string[],
    logoutUri?: string[],
    enforceScopeValidation?: true
}

export type IdentityApplicationTypes = "application" | "service-application" | "resource" | "resource-server";


export const formatError = (error: any, defaultMessage: string) => error?.response?.data?.code !== undefined && error.response.data.message ? error.response.data.message : defaultMessage;
export type IdentityApplicationPublishType = "publish" | "update";

@APIResource(CloudConsoleClient, "publisher/v2")
class ConsentApprovalFactory {

    @APIMethod("/applications/:consumerKey/consent", { options: { noTrailingSlash: true } })
    public submitApprovalRequest(consumerKey: string, request?: any) {
         const context = apiMethodContext(arguments);

        return from(new Promise<IdentityApplication>((resolve, reject) => {
            CloudConsoleClient.put(context, request, {
                params: {
                    consumerKey,
                }
            }).then(
                (response: any) => resolve(response.data),
                (error: any) => reject(formatError(error, "Unknown error occured while updating the application"))
            );
        }));
    }

    @APIMethod("/approvals/notify?type=CONSENT", { options: { noTrailingSlash: true } })
    public notifyApprovers(request: any) {
        const context = apiMethodContext(arguments);

        return from(new Promise<void>((resolve, reject) => {
            CloudConsoleClient.put(context, {
                ...request,
                type: 'CONSENT'
            }).then(
                () => resolve(),
                (error: any) => reject(formatError(error, "Unknown error occurred while notifying approvers"))
            );
        }));
    }

    @APIMethod("/approvals/approve", { options: { noTrailingSlash: true } })
    public approve(request: any, params: any) {
        const context = apiMethodContext(arguments);

        return from(new Promise<void>((resolve, reject) => {
            CloudConsoleClient.put(context, request,{
              
                params : {
                    ...params,
                    type: 'CONSENT'
                }
            }).then(
                () => resolve(),
                (error: any) => reject(formatError(error, "Unknown error occurred while notifying approvers"))
            );
        }));
    }

    @APIMethod("/approvals/deny", { options: { noTrailingSlash: true } })
    public deny(request: any, params:any) {
        const context = apiMethodContext(arguments);

        return from(new Promise<void>((resolve, reject) => {
            CloudConsoleClient.put(context, request,{
                params : {
                    ...params,
                    type: 'CONSENT'
                }
            }).then(
                () => resolve(),
                (error: any) => reject(formatError(error, "Unknown error occurred while notifying approvers"))
            );
        }));
    }

}

const ConsentApprovalService = new ConsentApprovalFactory();

export default ConsentApprovalService;